import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../components/mensajes2";
import { Dimmer } from "../spinner";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import moment from "moment";
import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input } from "../../ui/inputs/Input";

export const ModalContabilizarIngreso = (props) => {
  var op = require("../../../src/modulos/datos");
  const fechasistema = JSON.parse(localStorage.getItem("fechasistema"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtFechaFin = useRef();
  const txtFechaIni = useRef();

  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  let token = localStorage.getItem("jwtToken");
  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;

    if (txtFechaIni.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la fecha de inicio.",
        icono: "informacion",
      });

      sigue = false;
      txtFechaIni.current.focus();
    } else if (txtFechaFin.current.value === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la fecha a culminar.",
        icono: "informacion",
      });

      sigue = false;
      txtFechaFin.current.focus();
    } else if (txtFechaIni.current.value > txtFechaFin.current.value) {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto:
          "La fecha de inicio no debe ser mayor a la fecha de culminanción.",
        icono: "informacion",
      });

      sigue = false;
      txtFechaFin.current.focus();
    } else if (sigue) {
      if (props.desde === 2) {
        crearReversaAsientoIngreso();
      } else {
        validarVinculacionCuentas();
      }
    }
  };
  const cerrarModal = () => {
    //props.onHideRenderizar();

    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });

    //props.setShow(false);
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    crearReversaAsientos();
  };
  const crearReversaAsientoIngreso = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/crearreversarasientoingreso`;
    let body;
    setActivate(true);

    body = {
      fechaini: txtFechaIni.current.value,
      fechafin: txtFechaFin.current.value,
      idefi: idefiscal,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Proceso Terminado.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

      });
  };

  const validarVinculacionCuentas = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/validarvinculacioncuentas?idefiscal=${idefiscal} `;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setMensajesino({ mostrar: true, titulo: 'Confirmación.', texto: 'Existen Cuentas Presupuestarias Sin Vincular \n Desea Continuar?', icono: 'confirmacion' });
          } else {
            crearReversaAsientos();
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
      });
  };

  const crearReversaAsientos = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/validarvinculacioncuentas?idefiscal=${idefiscal} `;
    let body;
    setActivate(true);

    body = {
      fechaini: txtFechaIni.current.value,
      fechafin: txtFechaFin.current.value,
      idefi: idefiscal,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Proceso Terminado.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });

      });
  };

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setOperacion();
    setDeshabilitado();
    setVisible();
  };
  const salir = () => {
    props.setShow(false);
    blanquearCampos();
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        //setDeshabilitado(props.deshabilitado);
        //setOperacion(props.operacion);
        setVisible(false);
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">
          Actualización de Asientos Contables
        </h3>
        <a type="button"
          ref={btnCancela}
          className="fw-bold text-light fs-6"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto m-0">
            Actualizar Asientos Contables
          </legend>

          <div className="col-6 m-0 p-0">
            <Input label='Desde:'
              type="date"
              defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
              max={moment.utc(fechasistema).format("YYYY-MM-DD")}
              ref={txtFechaIni}
            />
          </div>

          <div className="col-6 m-0 p-0">
            <Input label='Hasta:'
              type="date"
              defaultValue={moment.utc(fechasistema).format("YYYY-MM-DD")}
              max={moment.utc(fechasistema).format("YYYY-MM-DD")}
              ref={txtFechaFin}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={validarCampos}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          onClick={salir}
          ref={btnCancela}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
